class Reviews {

    //#region General/Global Properties

    reviewsLocation = document.getElementById("reviews");
    cottageCode = this.reviewsLocation.getAttribute('data-cottage-code');
    pageCount = parseInt(this.reviewsLocation.getAttribute('data-page-count'), 10);
    initialPageNum = parseInt(this.reviewsLocation.getAttribute('data-initial-page'), 10);
    showMore = document.getElementById("show-more-btn");
    pagingContainer = document.getElementById("paging-container");
    pagingDisplay = document.getElementById("paging-display");
    prevPageButton = document.getElementById("prev-page-button");
    nextPageButton = document.getElementById("next-page-button");
    endpoint = "/feeds/reviewCommentsFeed.aspx";

    // Review character length properties (dynamically populated on first call before used in a global context)
    maximumCharLengthOfReview;
    maximumCharLengthOfReviewWithBuffer;

    //#endregion

    //#region constructor

    constructor() {

        // Bottom [Show More] Reviews method binding
        this.showMoreReviews = this.showMoreReviews.bind(this);
        this.getMoreReviews = this.getMoreReviews.bind(this);
        this.getLoadMoreNextPageNum = this.getLoadMoreNextPageNum.bind(this);
        this.updateCurrentLoadMorePageRange = this.updateCurrentLoadMorePageRange.bind(this);
        this.updateCurrentLoadMorePageRangeStart = this.updateCurrentLoadMorePageRangeStart.bind(this);
        this.updateCurrentLoadMorePageRangeEnd = this.updateCurrentLoadMorePageRangeEnd.bind(this);
        this.hideLoadMore = this.hideLoadMore.bind(this);

        // Pagination method bindings
        this.getPrevPaginationInfo = this.getPrevPaginationInfo.bind(this);
        this.getNextPaginationInfo = this.getNextPaginationInfo.bind(this);
        this.disablePagingPrevButton = this.disablePagingPrevButton.bind(this);
        this.disablePagingNextButton = this.disablePagingNextButton.bind(this);
        this.updatePagingDisplay = this.updatePagingDisplay.bind(this);

        // Utilities 
        this.updateReviewPageURLParam = this.updateReviewPageURLParam.bind(this);
        this.checkIntitalQueryStringIsInRange = this.checkIntitalQueryStringIsInRange.bind(this);

        // Review HTML templating method binding
        this.reviewHTMLTemplate = this.reviewHTMLTemplate.bind(this);
    }

    //#endregion

    //#region Utilites

    // Update 'reviewpage' page URL params
    updateReviewPageURLParam = (requestedPage) => {
        const firstPage = requestedPage === 1;
        const currentUrl = new URL(window.location.href);
        const newPageState = firstPage ? {} : { reviewpage: requestedPage };

        currentUrl.searchParams.delete('reviewpage');

        if (!firstPage) {
            currentUrl.searchParams.set('reviewpage', requestedPage);
        }

        history.pushState(newPageState, "", currentUrl.toString());
    }


    // Ensure that the review page query parameter is within the valid range
    checkIntitalQueryStringIsInRange = () => {
        const reviewPageQueryParam = new URLSearchParams(window.location.search).get('reviewpage');
        if (reviewPageQueryParam && reviewPageQueryParam > this.pageCount) {
            this.updateReviewPageURLParam(this.pageCount);
        }
    }


    //#endregion

    //#region Bottom [Show More] Reviews

    // Set inital show more page number
    currentLoadMorePageRange = { start: parseInt(this.initialPageNum, 10), end: parseInt(this.initialPageNum, 10) };

    // Get the next page number, constrained within the maximum page count, for show more functionality
    getLoadMoreNextPageNum = () => {
        const nextPage = this.currentLoadMorePageRange.end + 1;
        return nextPage > this.pageCount ? this.pageCount : nextPage;
    }

    // Update the next page number for show more functionality
    updateCurrentLoadMorePageRange = (start, end) => { this.currentLoadMorePageRange.start = start; this.currentLoadMorePageRange.end = end };
    updateCurrentLoadMorePageRangeStart = (pageNumber) => this.currentLoadMorePageRange.start = pageNumber;
    updateCurrentLoadMorePageRangeEnd = (pageNumber) => this.currentLoadMorePageRange.end = pageNumber;

    // Hide or show 'Load More' button
    hideLoadMore = (hide) => this.showMore.setAttribute('aria-hidden', hide);

    // load more readmore when 'Load More' button is clicked
    showMoreReviews = () => {
        const requestedPage = this.getLoadMoreNextPageNum();
        this.updatePagingDisplay(`${this.currentLoadMorePageRange.start}-${requestedPage}`);
        this.getMoreReviews(requestedPage, false);
        this.updateCurrentLoadMorePageRangeEnd(requestedPage);
        this.hideLoadMore(requestedPage === this.pageCount);

        // Deal with crossover in pagination 
        this.updateCurrentPaginationPage(requestedPage);
        this.disablePagingNextButton(requestedPage === this.pageCount);
    }


    //#endregion

    //#region Fetch Reviews

    // Asynchronously load more readmore from the server/feed
    async getMoreReviews(requestedPage, replaceReviews) {

            // Construct the query string for call
            const queryString = `?cottagecode=${this.cottageCode}&reviewpage=${requestedPage}&usepagination=Y`;
            const callURL = this.endpoint + queryString;

        // Set loading state if replacing readmore
        if (replaceReviews) this.setLoadingState(true);

        // Callback for successful fetch
        const loadMoreReviewsSuccess = (data) => {

            // Update maximum character lengths
            this.maximumCharLengthOfReview = data.MaximumCharLengthOfReview;
            this.maximumCharLengthOfReviewWithBuffer = data.MaximumCharLengthOfReviewWithBuffer;

            // If replacing remove the current readmore
            if (replaceReviews) this.reviewsLocation.innerHTML = "";

            // Loop through and create/insert readmore 
            data.Reviews.forEach(review => {
                const reviewHTML = this.reviewHTMLTemplate(review);
                this.reviewsLocation.insertAdjacentHTML("beforeend", reviewHTML);
            });

            // Reset loading state if replacing readmore
            if (replaceReviews) this.setLoadingState(false);
        }

        // Callback for fetch error
        const loadMoreReviewsError = (errorMessage) => {
            console.log(errorMessage);
            this.pagingContainer.remove();
            this.showMore.remove();
            if (replaceReviews)
                this.setLoadingState(false);
        }

        try {
            // Fetch reviews from feed
            const response = await fetch(callURL);
            if (response.ok) {
                const data = await response.json();
                loadMoreReviewsSuccess(data);
            } else
                loadMoreReviewsError(`${response.status} - ${response.statusText}`);
        } catch (error) {
            // Handle fetch error
            loadMoreReviewsError(error.message);
        }
    }

    //#endregion

    //#region Pagination

    // Set inital pagination page number
    currentPaginationPageNum = parseInt(this.initialPageNum, 10);

    // Update the current pagination page number
    updateCurrentPaginationPage = (page) => this.currentPaginationPageNum = page;

    // Set loading state for readmore container
    setLoadingState(loading) {
        this.reviewsLocation.classList.toggle('loading', loading);
    }

    // Get information for the next pagination page number
    getNextPaginationInfo = () => {
        const nextPage = this.currentPaginationPageNum + 1;
        return {
            NextPageIsLast: nextPage === this.pageCount,
            NextPageNumber: nextPage
        };
    }

    // Get information for the previous pagination page
    getPrevPaginationInfo = () => {
        const prevPage = this.currentPaginationPageNum - 1;
        return {
            PrevPageIsFirst: prevPage === 1,
            PrevPageNumber: prevPage
        };
    };

    // Update the current page in the pagination (e.g. Page 1 of 4)
    updatePagingDisplay(currentPage) {
        this.pagingDisplay.querySelector(".current-page").innerHTML = currentPage;
    }

    // Disable or enable the [Next] pagination button
    disablePagingNextButton = (disable) => {
        this.nextPageButton.setAttribute("data-disabled", disable);
    }

    // Disable or enable the [Prev] pagination button
    disablePagingPrevButton = (disable) => {
        this.prevPageButton.setAttribute("data-disabled", disable);
    }

    // Handle click on the [Prev] button
    reviewsPrevPage() {
        const { PrevPageIsFirst, PrevPageNumber } = this.getPrevPaginationInfo();

        // Enable/Disable pagination buttons
        this.disablePagingNextButton(false);
        this.disablePagingPrevButton(PrevPageIsFirst);

        // Update current pagination page
        this.updateCurrentPaginationPage(PrevPageNumber);

        // Update next page for show more functionality
        this.updateCurrentLoadMorePageRange(PrevPageNumber, PrevPageNumber);
        this.hideLoadMore(false);

        // Load more readmore for the previous page
        this.getMoreReviews(PrevPageNumber, true);
        this.updatePagingDisplay(PrevPageNumber);
        this.updateReviewPageURLParam(PrevPageNumber);
    }

    // Handle click on the [Next] button
    reviewsNextPage() {
        const { NextPageIsLast, NextPageNumber } = this.getNextPaginationInfo();

        // Enable/Disable pagination buttons
        this.disablePagingPrevButton(false);
        this.disablePagingNextButton(NextPageIsLast);

        // Update current pagination page
        this.updateCurrentPaginationPage(NextPageNumber);

        // Update next page for show more functionality
        this.updateCurrentLoadMorePageRange(NextPageNumber, NextPageNumber);
        this.hideLoadMore(NextPageIsLast);

        // Load more readmore for the next page
        this.getMoreReviews(NextPageNumber, true);
        this.updatePagingDisplay(NextPageNumber);
        this.updateReviewPageURLParam(NextPageNumber);
    }

    //#endregion

    //#region Reviews HTML Template

    // Generate HTML for a review
    reviewHTMLTemplate(review) {
        const reviewDate = new Date(review.ToDate);
        const reviewMonth = reviewDate.toLocaleString('en-GB', { month: 'long' });
        const reviewYear = reviewDate.getFullYear();
        const { TenantName, Comment, ModeratorReply } = review;

        // Start block
        let html = `<div class="property-reviews__review">
                            <p>
                                <span class="property-reviews__name">${TenantName}</span>
                                <span class="property-reviews__date">${reviewMonth} ${reviewYear}</span>
                            </p>`;

        // Handle the guest comment section
        if (Comment.length > this.maximumCharLengthOfReviewWithBuffer) {
            // Truncated Long Comment
            html += `<div class="read-more-container">
                            <p>${Comment.substring(0, this.maximumCharLengthOfReview)}<span class="truncated">${Comment.substring(this.maximumCharLengthOfReview)}</span>
                                <span class="ellipsis">...</span>
                            </p>
                            <p class="read-more-btn">Read all...</p>
                         </div>`;
        }
        else {
            // Normal Comment
            html += `<div>${Comment}</div>`;
        }

        // Handle the our reply section
        if (ModeratorReply && ModeratorReply.trim() !== "") {
            html += `<div class="property-reviews__reply${ModeratorReply.length > this.maximumCharLengthOfReviewWithBuffer ? ' read-more-container' : ''}">
                         <p class="property-reviews__reply-title">Reply from Classic Cottages</p>`;
            if (ModeratorReply.length > this.maximumCharLengthOfReviewWithBuffer) {
                // Truncated Long Reply
                html += `<p>${ModeratorReply.substring(0, this.maximumCharLengthOfReview)}<span class="truncated">${ModeratorReply.substring(this.maximumCharLengthOfReview)}</span>
                                <span class="ellipsis">...</span>
                             </p>
                             <p class="read-more-btn">Read all...</p>`;
            }
            else {
                // Normal Reply
                html += `<p>${ModeratorReply}</p>`;
            }
        }

        // Close the review HTML
        html += `</div>`;

        return html;
    }

    //#endregion

}

// Check before creating an instance of the Reviews class
const reviewsContainer = document.querySelector("body.cottage #reviews");
if (reviewsContainer) {

    if (reviewsContainer.dataset.pagination == "true") {
        // Create an instance of the Reviews class
        const reviews = new Reviews();

        //#region Add Click Events 

        const handlePrevPageClick = (event) => {
            event.preventDefault();
            reviews.reviewsPrevPage(reviews);
        };

        const handleNextPageClick = (event) => {
            event.preventDefault();
            reviews.reviewsNextPage(reviews);
        };

        const handleshowMoreReviewsClick = (event) => {
            reviews.showMoreReviews(reviews);
        };

        // Attach onclick event of pagination 'Previous Page' button
        reviews.prevPageButton.addEventListener('click', handlePrevPageClick);

        // Attach onclick event of pagination 'Next Page' button
        reviews.nextPageButton.addEventListener('click', handleNextPageClick);

        // Attach onclick event of show more 
        reviews.showMore.addEventListener('click', handleshowMoreReviewsClick);

        // Check query string
        reviews.checkIntitalQueryStringIsInRange();


        //#endregion
    }
    else {
        // Remove 'reviewpage' parameter if present in the URL on non paginationed reviews page
        const url = new URL(window.location.href);

        if (url.searchParams.has('reviewpage')) {
            url.searchParams.delete('reviewpage');
            window.history.replaceState({}, "", url.href);
        }
    }
}
